import { usePumpSizing } from "../../../context/PumpSizingContext";
import { CheckboxField } from "../../shared/CheckboxField";
import { TextField } from "../../shared/TextField";
import { TdhHelpFields } from "./TdhHelpFields";

export function TdhSumpHelp() {
	const { formData, updateSumpTdh } = usePumpSizing();
	const { sump } = formData.tdhData;

	return (
		<TdhHelpFields
			help={sump}
			onUpdate={updateSumpTdh}
			staticHeadLabel="Static Head (ft)*"
			pipeDiameterLabel="Pipe Diameter (in)*"
			pipeMaterialLabel="Pipe Material*"
			horizontalLengthLabel="Horizontal Length of Pipe (ft)*"
			middleContent={
				<div className="pf-tdh-help__force-main">
					<CheckboxField
						label="Discharge into Force Main?"
						checked={sump.dischargeIntoForceMain}
						onChange={(checked) =>
							updateSumpTdh({ dischargeIntoForceMain: checked })
						}
					/>

					{sump.dischargeIntoForceMain ? (
						<TextField
							label="PSI*"
							type="number"
							value={sump.psi}
							onChange={(event) =>
								updateSumpTdh({ psi: event.target.value })
							}
							min="0"
							step="any"
							className="pf-field-group--medium"
						/>
					) : null}
				</div>
			}
		/>
	);
}
